import { render, staticRenderFns } from "./apiCheckCrm.vue?vue&type=template&id=b87dcf4c&scoped=true&"
import script from "./apiCheckCrm.vue?vue&type=script&lang=js&"
export * from "./apiCheckCrm.vue?vue&type=script&lang=js&"
import style0 from "./apiCheckCrm.vue?vue&type=style&index=0&id=b87dcf4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87dcf4c",
  null
  
)

export default component.exports